export { lazyImport } from "./lazy-import";
